import {
  DeleteOutlined,
  FileTextOutlined,
  PaperClipOutlined,
  UploadOutlined,
} from '@ant-design/icons'
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Switch,
  Tooltip,
  Upload,
  message,
} from 'antd'
import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import React, { memo, useCallback, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import { DebounceSelect } from '../../components/DebounceSelect'
import EmptyContent from '../../components/EmptyContent'
import PageTitle from '../../components/PageTitle'
import PopupRenameFile from '../../components/PopupRenameFile'
import {
  DATE_FORMAT_LIST,
  DIGITAL_SIGN_PROVIDER,
  DIGITAL_TYPE_SIGN_SYSTEM,
  ISO_DATE_FORMAT,
} from '../../constants'
import { Container } from '../../layouts/Container/Container'
import DashboardLayout from '../../layouts/DashboardLayout/DashboardLayout'
import utils from '../../utils'
import validator from '../../validator'
import {
  UploadFileListItem,
  UploadFileListWrapper,
} from '../ConnectedDocumentOutgoingDocCreatePage/ConnectedDocumentOutgoingDocCreatePageStyled'
import { FormActionFooter } from './CateDocumentOutgoingDocUpdatePageStyled'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'

const { Option } = Select
const { TextArea } = Input

const CateDocumentOutgoingDocUpdatePage = props => {
  const {
    history,
    fileStore,
    loadingAnimationStore,
    authenticationStore,
    organizationStore,
    cateStore,
    cateDocumentStore,
    match,
    signedDocumentStore,
    electronicDocumentStore,
  } = props
  const { listOrgan } = cateStore
  const { selectedElectronicDocument } = electronicDocumentStore
  const { sentCateDocument } = cateDocumentStore
  const location = useLocation()
  const submitValuesInternal = location.state?.data
  const organizationValue = location.state?.extendData?.organizations
  const fileRelease = location.state?.extendData?.fileRelease // file trình ký
  const fileResponse = location.state?.extendData?.response //file nhận từ tài liệu đính kèm

  const { documentId } = match.params
  const [document, setDocument] = useState(null)
  const [organId, setOrganId] = useState(null)
  const [form] = Form.useForm()
  const [formRenameFile] = Form.useForm()

  // For Rename file
  const [fileExt, setFileExt] = useState(undefined)
  const [fileTargetRename, setFileTargetRename] = useState(null)
  const [isRenameFileFromInternal, setIsRenameFileFromInternal] = useState(
    false
  )
  const [isModalVisibleRenameFile, setIsModalVisibleRenameFile] = useState(
    false
  )
  const [isRenameFileUpdate, setIsRenameFileUpdate] = useState(false)
  const [dataSignSavis, setDataSignSavis] = useState()
  // Ký số popup
  const [isVisiblePopupSign, setIsVisiblePopupSign] = useState(false)
  const [fileListUpdate, setFileListUpdate] = useState([])
  // List file nhận từ thiết bị
  const [fileList, setFileList] = useState([])
  // List file nhận từ trục
  const [fileFromInternal, setFileFromInternal] = useState([])

  const [showDocumentList, setShowDocumentList] = useState(false)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [showCompanyReceiver, setShowCompanyReceiver] = useState(true)
  const [organList, setOrganList] = useState([])
  const [listFile, setListFile] = useState([]) // Tổng hợp file đính kèm, file trình ký
  useEffect(() => {
    listOrgan()
      .then(res => {
        setOrganList(res.data)
      })
      .catch(error => message.error(error.vi))
  }, [])

  useEffect(() => {
    if (fileRelease) {
      const mergedList = [fileRelease, ...fileResponse]
      setListFile(mergedList)
    }
  }, [fileRelease, fileResponse])

  useEffect(() => {
    if (!submitValuesInternal) return
    const typeMapping = {
      '021': 3,
      '022': 4,
      '024': 5,
      '020': 6,
      '025': 7,
    }
    const urgencyLevelMapping = {
      '001': 1,
      '002': 3,
      '003': 4,
      '004': 0,
      '005': 2,
    }

    form.setFieldsValue({
      type: typeMapping[submitValuesInternal.document_type] || undefined,
      priority:
        urgencyLevelMapping[submitValuesInternal.urgency_level] || undefined,
      document_number: submitValuesInternal.document_number,
      promulgation_date: moment(submitValuesInternal.date_issued),
      organizations: organizationValue,
      to_places: submitValuesInternal.receive_address,
      full_name: submitValuesInternal.signer,
      subject: submitValuesInternal.title,
    })
  }, [submitValuesInternal])

  useEffect(() => {
    if (documentId) {
      loadingAnimationStore.showSpinner(true)
      cateDocumentStore
        .getDocumentsOutgoingById(documentId)
        .then(res => {
          setDocument(res.data)
          setFileListUpdate([...toJS(res.data.attachments)])
          let options = res.data.organs.map(organ => {
            return {
              key: organ.organId,
              value: organ.organId,
              label: organ?.organName,
            }
          })

          setOrganId(res.data.organId)
          form.setFieldsValue({
            document_number: res.data.documentNumber,
            bussiness_doc_type: '0',
            priority: res.data.priority,
            type: res.data.type,
            type_name: res.data.typeName,
            promulgation_amount: 1,
            page_amount: 1,
            direction: false,
            paper: true,
            steering_type: res.data.steeringType,
            organizations: options,
            code_number: res.data.code && res.data.code.split('/')[0],
            code_notation: res.data.code && res.data.code.split('/')[1],
            promulgation_date:
              res.data.promulgationDate && moment(res.data.promulgationDate),
            subject: res.data.subject,
            content: res.data.content,
            competence: res.data.competence,
            full_name: res.data.fullname,
            position: res.data.position,
          })
        })
        .finally(() => loadingAnimationStore.showSpinner(false))
    }
  }, [documentId])

  const handleCancelCreate = id => {
    form.resetFields()
    if (documentId || id) {
      history.push(`/cate-document/outgoing-document/view/${documentId || id}`)
    } else {
      history.push('/cate-document/outgoing-document')
    }
  }

  const handleCreateOutgoingDocument = useCallback(
    async submitData => {
      if (documentId) {
        loadingAnimationStore.showSpinner(true)
        try {
          await cateDocumentStore.updateCateDocument(submitData)
          handleCancelCreate(submitData.id)
          message.success(`Cập nhật văn bản thành công`)
        } catch (error) {
          message.error(error.vi)
        } finally {
          loadingAnimationStore.showSpinner(false)
        }
      } else {
        loadingAnimationStore.showSpinner(true)
        try {
          // Tạo mới văn bản
          const createRes = await cateDocumentStore.createCateDocument(
            submitData
          )
          const newId = createRes.data?.id
          if (newId) {
            await sentCateDocument({ id: newId, document_status_id: 1 })
            const listRes = await cateDocumentStore.getDocumentsOutgoing({
              bussiness_doc_type: undefined,
              status: undefined,
              title: undefined,
              page: 0,
              size: 10,
            })
            // Chuyển trang trước
            history.push('/cate-document/outgoing-document', {
              fromCreate: true,
              updatedList: listRes.data.data,
              total: listRes.data.total_count,
            })
            // Rồi mới hiển thị message
            message.success('Tạo văn bản thành công')
          }
        } catch (error) {
          message.error(error.vi || 'Có lỗi xảy ra')
        } finally {
          loadingAnimationStore.showSpinner(false)
        }
      }
    },
    [documentId, history, handleCancelCreate]
  )

  const onFinish = async values => {
    const {
      appendixes,
      bussiness_doc_reason,
      bussiness_doc_type,
      competence,
      content,
      direction,
      due_date,
      file_upload,
      full_name,
      page_amount,
      paper,
      place,
      position,
      priority,
      promulgation_amount,
      promulgation_date,
      sphere_of_promulgation,
      steering_type,
      subject,
      to_places,
      type,
      type_name,
      typer_notation,
      organizations,
      document_number,
    } = values

    // loadingAnimationStore.showSpinner(true)
    // download -> upload file từ văn bản nội bộ vimc

    const idFileUploadFromInternal = fileListUpdate.map(file => file.fileId)

    const batchUploadArr = []
    fileList.forEach(file => {
      const formData = new FormData()
      formData.append('file', file.originFileObj, file.name)
      batchUploadArr.push(fileStore.uploadFile(formData))
    })

    Promise.all(batchUploadArr)
      .then(response => {
        const submitValues = {
          attachments: response
            .map(response => response.data.file_id)
            .concat(idFileUploadFromInternal)
            .concat(listFile?.map(file => file.file_id)),
          bussiness: {
            bussiness_doc_reason: bussiness_doc_reason,
            document_id: '',
            paper: '0',
          },
          message_header: {
            code: {
              code_notation: document_number.split('/')[1],
              code_number: document_number.split('/')[0],
            },
            content: content ? content : '',
            document_type: {
              type: type,
              type_name: type_name ? type_name : '',
            },
            due_date: due_date ? moment(due_date).format(ISO_DATE_FORMAT) : '',
            other_info: {
              appendixes: appendixes ? [appendixes] : [],
              direction: direction,
              page_amount: page_amount ? page_amount : '',
              promulgation_amount: promulgation_amount
                ? promulgation_amount
                : '',
              priority: priority,
              sphere_of_promulgation: sphere_of_promulgation
                ? sphere_of_promulgation
                : '',
              typer_notation: typer_notation ? typer_notation : '',
            },
            promulgation_info: {
              place: place ? place : '',
              promulgation_date: moment(promulgation_date).format(
                ISO_DATE_FORMAT
              ),
            },
            signer_info: {
              competence: competence ? competence : '',
              full_name: full_name ? full_name : '',
              position: position ? position : '',
            },
            steering_type: steering_type,
            subject: subject,
            to_places: to_places ? [to_places] : [],
          },
          organ_id: organizations
            .map(organization => organization.value)
            .join(','),
          id: documentId,
        }
        handleCreateOutgoingDocument(submitValues)
      })
      .catch(error => {
        message.error(error.vi)
        loadingAnimationStore.showSpinner(false)
      })
  }
  const handleChangeFile = info => {
    if (info.fileList.length === 0) {
      form.setFieldsValue({ file_upload: undefined })
      setFileList([])
      return
    }
    const filteredFileList = info.fileList.filter(
      (elem, index, fileList) =>
        fileList.findIndex(file => file.name === elem.name) === index
    )
    setFileList(filteredFileList)
  }

  const handleRemoveFileFromUploadList = useCallback(
    fileUID => {
      const newFileList = fileList.filter(file => file.uid !== fileUID)
      setFileList(newFileList)
      if (newFileList.length === 0 && listFile?.length === 0) {
        form.setFieldsValue({
          attachments: [],
        })
      }
    },
    [fileList]
  )

  const handleRemoveListFileFromUploadList = useCallback(
    fileUID => {
      const newFileList = listFile.filter(file => file.file_id !== fileUID)
      setListFile(newFileList)
      if (newFileList.length === 0 && fileList?.length === 0) {
        form.setFieldsValue({
          attachments: [],
        })
      }
    },
    [listFile]
  )

  const onSelectChange = selectedRowKeys => {
    setSelectedRowKeys(selectedRowKeys)
  }
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  }

  const getTypeFile = nameFile => '.' + nameFile.split('.').pop()
  const removeFileExt = fileName => {
    return fileName.split('.').slice(0, -1).join('.')
  }

  const handleRemoveFileFromInternal = file_id => {
    setFileFromInternal(
      toJS([...fileFromInternal]).filter(file => file.id !== file_id)
    )
  }
  const renameFile = (originalFile, newName) => {
    return new File([originalFile], newName, {
      type: originalFile.type,
      lastModified: originalFile.lastModified,
    })
  }

  const submitRenameFile = async value => {
    const index = fileTargetRename?.index
    setIsModalVisibleRenameFile(false)
    // đổi tên file nhận từ trục
    if (isRenameFileFromInternal) {
      const fileFromInternalAfterRename = [...fileFromInternal]
      fileFromInternalAfterRename[index] = {
        id: fileTargetRename.id,
        fileName: value.rename + fileExt,
      }
      setFileFromInternal(fileFromInternalAfterRename)
      return
    }
    // đổi tên file nhận từ thiết bị
    const newFileList = [...fileList]
    newFileList[index].fileName = value.rename + fileExt
    newFileList[index].originFileObj = renameFile(
      newFileList[index].originFileObj,
      newFileList[index].fileName
    )
    setFileList(newFileList)
  }
  useEffect(() => {
    if (!document || !document.attachments || !document.attachments.length)
      return
    setFileFromInternal([...toJS(document.attachments)])
  }, [document])

  // sign popup
  const handleClosePopupSign = () => {
    setIsVisiblePopupSign(false)
    signedDocumentStore.clearFilePDFSign()
  }

  const handleOpenPopupSign = (file, index) => {
    setDataSignSavis({
      file: file.originFileObj,
      index: index,
    })
    const fileBlob = new Blob([file.originFileObj], { type: 'application/pdf' })
    signedDocumentStore.setFileBlob(fileBlob)
    signedDocumentStore.setOriginFileObj(file.originFileObj)
    setIsVisiblePopupSign(true)
  }

  const handleBeforeSign = (file, index) => {
    setFileRender(file)
    setDataSignSavis({
      file: file,
      index: index,
    })
  }
  const handleSignSavis = (file, index) => {
    loadingAnimationStore.showSpinner(true)
    const formData = new FormData()
    formData.append('file', file.originFileObj)
    fileStore.uploadFile(formData)
    fileStore
      .uploadFile(formData)
      .then(res => {
        const dataSubmit = {
          image: '',
          reason: 'Signed',
          location: 'VietNam',
          provider: DIGITAL_SIGN_PROVIDER,
          contactInfo: '',
          type: DIGITAL_TYPE_SIGN_SYSTEM,
          isVisible: 1,
          page: 1,
          llx: 300,
          lly: 794,
          urx: 590,
          ury: 830,
          listSignFile: [
            {
              fileId: res.data.file_id,
            },
          ],
        }
        signedDocumentStore
          .signDocumentSavis(dataSubmit)
          .then(res => {
            const {
              fileSignId,
              fileOriginName,
              fileSignName,
            } = res.data.listSignFile[0]
            const newFileList = [...fileList]
            newFileList[index] = {
              name: fileSignName,
              id: fileSignId,
              uid: file.uid,
              isSigned: true,
              type: 'application/pdf',
            }
            setFileList(newFileList)
            loadingAnimationStore.showSpinner(false)
            message.success(`Văn bản "${fileOriginName}" đã được kí`)
          })
          .catch(err => {
            loadingAnimationStore.showSpinner(false)
            return message.error(err?.vi || 'Ký số thất bại!')
          })
      })
      .catch(() => loadingAnimationStore.showSpinner(false))
  }

  const [fieldsRenameFile, setFieldsRenameFile] = useState([
    {
      name: ['rename'],
      value: '',
    },
  ])

  const handleOpenPopupRenameFile = (file, index) => {
    setFieldsRenameFile([
      {
        name: ['rename'],
        value: utils.removeExtensionFile(file.fileName),
      },
    ])
    setFileExt('.' + utils.getExtensionFile(file.fileName))
    setFileTargetRename({
      ...file,
      index: index,
    })
    setIsModalVisibleRenameFile(true)
  }

  const handleRemoveFileUpdate = file_id => {
    const newFileList = fileListUpdate.filter(file => file.fileId !== file_id)
    setFileListUpdate(newFileList)
  }

  const renderListFileUpdate =
    fileListUpdate &&
    fileListUpdate.map((file, index) => (
      <UploadFileListItem key={file.fileId}>
        <FileTextOutlined style={{ color: '1890FF' }} />
        <span style={{ color: '#1890FF' }}>{file.fileName}</span>
        {/* <Button
          className={'rename'}
          type="text"
          onClick={() => {
            setIsRenameFileUpdate(true)
            handleOpenPopupRenameFile(file, index)
          }}>
          Đổi tên
        </Button> */}
        <Tooltip title={'Xoá tập tin'}>
          <DeleteOutlined
            onClick={() => handleRemoveFileUpdate(file.fileId, index)}
          />
        </Tooltip>
      </UploadFileListItem>
    ))

  return (
    <DashboardLayout>
      <Helmet>
        <title>
          {document ? 'Cập nhật' : 'Tạo mới'} văn bản đi | Quản lý trục liên
          thông
        </title>
      </Helmet>
      <PageTitle location={props.location} title={'Tạo văn bản đi'} />
      <ContentBlockWrapper>
        <Container maxWidth={820}>
          <Form
            form={form}
            scrollToFirstError={true}
            name={'create-outgoing-document'}
            layout={'vertical'}
            onFinish={onFinish}
            initialValues={{
              code: document?.code,
              title: document?.title,
              // type: '',
              // priority: '',
              // type_name: '',
              // promulgation_amount: 1,
              // page_amount: 1,
              direction: false,
              paper: true,
              // steering_type: '0',
              // bussiness_doc_type: 0,
              // organizations: defaultOption,
              // full_name: dataReceiveDocument && dataReceiveDocument.signer,
              // subject: document?.subject,
              // promulgation_date:
              //   document?.promulgation_date &&
              //   moment(document?.promulgation_date),
            }}>
            <Row type={'flex'} gutter={30}>
              {/* <Col xs={24} md={12}>
                <Form.Item
                  label={'Số văn bản'}
                  name={'code_number'}
                  rules={[
                    { required: true, message: 'Vui lòng nhập số văn bản!' },
                    { validator: validator.validateInputString },
                  ]}>
                  <Input maxLength={11} placeholder={'Nhập số văn bản đi'} />
                </Form.Item>
              </Col> */}
              <Col xs={24} md={12}>
                <Form.Item
                  label={'Số ký hiệu'}
                  name={'document_number'}
                  rules={[
                    {
                      required: true,
                      message: ' Vui lòng nhập số ký hiệu!',
                    },
                    { validator: validator.validateInputString },
                  ]}>
                  <Input maxLength={30} placeholder={'Nhập số ký hiệu'} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  label={'Ngày ban hành'}
                  name={'promulgation_date'}
                  rules={[
                    {
                      required: true,
                      message: ' Vui lòng chọn ngày ban hành văn bản!',
                    },
                  ]}>
                  <DatePicker
                    style={{ width: '100%' }}
                    format={DATE_FORMAT_LIST}
                  />
                </Form.Item>
              </Col>
            </Row>
            {/* <Row type={'flex'} gutter={30}> */}
            {/* <Col xs={24} md={12}>
                <Form.Item label={'Ban hành'} name={'place'}>
                  <Input
                    maxLength={50}
                    placeholder={'Nhập cơ quan ban hành văn bản'}
                  />
                </Form.Item>
              </Col> */}
            {/* <Col xs={24} md={12}>
                <Form.Item
                  label={'Ngày ban hành'}
                  name={'promulgation_date'}
                  rules={[
                    {
                      required: true,
                      message: ' Vui lòng chọn ngày ban hành văn bản!',
                    },
                  ]}>
                  <DatePicker
                    style={{ width: '100%' }}
                    format={DATE_FORMAT_LIST}
                  />
                </Form.Item>
              </Col> */}
            {/* </Row> */}

            <Form.Item label={'Loại văn bản'} name={'type'}>
              <Select
                notFoundContent={<EmptyContent />}
                placeholder={'-- Chọn loại văn bản --'}>
                <Option value={2}>Văn bản hành chính</Option>
                <Option value={1}>Văn bản quy phạm pháp luật</Option>
                <Option value={3}>Công văn</Option>
                <Option value={4}>Quyết định</Option>
                <Option value={5}>Tờ trình</Option>
                <Option value={6}>Báo cáo</Option>
                <Option value={7}>Khác</Option>
              </Select>
            </Form.Item>

            <Form.Item label={'Tên loại văn bản'} name={'type_name'}>
              <Input maxLength={100} placeholder={'Nhập tên loại văn bản'} />
            </Form.Item>

            <Form.Item
              label={'Tiêu đề'}
              name={'subject'}
              rules={[
                { required: true, message: ' Vui lòng nhập tiêu đề văn bản!' },
                { validator: validator.validateInputString },
              ]}>
              <Input maxLength={500} placeholder={'Nhập tiêu đề văn bản'} />
            </Form.Item>

            <Form.Item label={'Nội dung văn bản'} name={'content'}>
              <TextArea
                rows={4}
                placeholder={
                  'Nhập nội dung văn bản, chỉ áp dụng đối với văn bản dạng phi cấu trúc có độ dài không quá 500 ký tự'
                }
              />
            </Form.Item>

            <Row type={'flex'} gutter={30}>
              <Col xs={24} md={12}>
                <Form.Item label={'Thẩm quyền'} name={'competence'}>
                  <Input maxLength={100} placeholder={'Nhập thẩm quyền'} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item label={'Người ký'} name={'full_name'}>
                  <Input maxLength={50} placeholder={'Nhập tên người ký'} />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item label={'Chức vụ người ký văn bản'} name={'position'}>
              <Input maxLength={500} placeholder={'Nhập chức danh người ký'} />
            </Form.Item>
            <Form.Item label={'Hạn trả lời văn bản'} name={'due_date'}>
              <DatePicker format={DATE_FORMAT_LIST} style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label={'Độ khẩn'} name={'priority'}>
              <Select
                notFoundContent={<EmptyContent />}
                placeholder={'-- Chọn độ khẩn --'}>
                <Option value={0}>Thường</Option>
                <Option value={1}>Khẩn</Option>
                <Option value={2}>Thượng khẩn</Option>
                <Option value={3}>Hỏa tốc</Option>
                <Option value={4}>Hỏa tốc hẹn giờ</Option>
              </Select>
            </Form.Item>
            <Form.Item
              label={'Lĩnh vực ban hành'}
              name={'sphere_of_promulgation'}>
              <Input maxLength={100} placeholder={'Nhập lĩnh vực ban hành'} />
            </Form.Item>
            <Row type={'flex'} gutter={30}>
              <Col xs={24} md={24}>
                <Form.Item
                  label={
                    'Ký hiệu đơn vị, tổ chức, chữ viết tắt tên người soạn thảo văn bản'
                  }
                  name={'typer_notation'}>
                  <Input maxLength={100} placeholder={'Nhập ký hiệu'} />
                </Form.Item>
              </Col>
              <Col xs={24} md={24}>
                <Form.Item
                  label={'Số lượng ban hành'}
                  name={'promulgation_amount'}>
                  <InputNumber style={{ width: '100%' }} min={1} max={10000} />
                </Form.Item>
              </Col>
            </Row>
            <Row type={'flex'} gutter={30}>
              <Col xs={24} md={12}>
                <Form.Item
                  label={'Tổng số trang của văn bản'}
                  name={'page_amount'}>
                  <InputNumber style={{ width: '100%' }} min={1} max={10000} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  label={'Ban hành theo chỉ đạo'}
                  name={'direction'}
                  valuePropName="checked">
                  <Switch />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item label={'Phụ lục'} name={'appendixes'}>
              <Input maxLength={200} placeholder={'Nhập thông tin phụ lục'} />
            </Form.Item>

            <Form.Item
              label={'Loại chỉ đạo'}
              name={'steering_type'}
              rules={[
                { required: true, message: ' Vui lòng chọn loại chỉ đạo!' },
                // { validator: validator.validateEmptyString },
              ]}>
              <Select
                notFoundContent={<EmptyContent />}
                placeholder={'-- Chọn loại chỉ đạo --'}>
                <Option value={0}>Không phải là chỉ đạo</Option>
                <Option value={1}>Chỉ đạo</Option>
                <Option value={2}>Báo cáo chỉ đạo</Option>
              </Select>
            </Form.Item>

            <Form.Item label={'Nơi nhận'} name={'to_places'}>
              <Input maxLength={1000} placeholder={'Nhập nơi nhận'} />
            </Form.Item>
            {/* <Form.Item
              label={'Loại nghiệp vụ văn bản'}
              name={'bussiness_doc_type'}
              rules={[
                {
                  required: true,
                  message: ' Vui lòng chọn loại nghiệp vụ văn bản!',
                },
                { validator: validator.validateEmptyString },
              ]}>
              <Select
                allowClear
                notFoundContent={<EmptyContent />}
                onChange={handleChangeBussinessDocType}
                placeholder={'-- Chọn loại xử lý --'}>
                <Option value={'0'}>Gửi văn bản mới</Option>
                <Option value={'1'}>Thu hồi văn bản đã gửi</Option>
                <Option value={'3'}>Thay thế văn bản đã gửi</Option>
              </Select>
            </Form.Item> */}

            {/* <Form.Item
              label={'Lý do ban hành'}
              name={'bussiness_doc_reason'}
              rules={[
                {
                  required: true,
                  message: ' Vui lòng nhập lí do ban hành văn bản!',
                },
                { validator: validator.validateInputString },
              ]}>
              <Input maxLength={200} placeholder={'Nhập lí do ban hành'} />
            </Form.Item> */}

            <Form.Item
              name={'attachments'}
              label={
                fileListUpdate.length !== 0 ? (
                  <>
                    <span
                      style={{
                        color: '#ff4d4f',
                        fontFamily: 'SimSun, sans-serif',
                        marginRight: '2px',
                      }}>
                      *{' '}
                    </span>
                    Tài liệu đính kèm
                  </>
                ) : (
                  'Tài liệu đính kèm'
                )
              }
              rules={
                fileListUpdate.length !== 0 || listFile?.length !== 0
                  ? null
                  : [
                      {
                        required: true,
                        message: ' Vui lòng chọn tài liệu đính kèm!',
                      },
                    ]
              }>
              <Upload
                valuePropName={'fileList'}
                fileList={fileList}
                multiple={true}
                beforeUpload={() => false}
                onChange={handleChangeFile}
                showUploadList={false}>
                <Button icon={<UploadOutlined />}>
                  Chọn tài liệu đính kèm
                </Button>
              </Upload>
            </Form.Item>
            {
              <UploadFileListWrapper>
                {fileList.map((file, index) => (
                  <UploadFileListItem
                    key={file.uid}
                    isSigned={file.isSigned}
                    isNotPDF={file.type !== 'application/pdf'}>
                    <FileTextOutlined />
                    <span>{file.name}</span>
                    {/* {file.isSigned ? (
                      <Button
                        className={'digital-signature'}
                        type="text"
                        onClick={() => message.info('Đã ký!')}>
                        Đã ký
                      </Button>
                    ) : file.type !== 'application/pdf' ? (
                      <AccessControlAction
                        aclActionType={ACL_ACTION_TYPE.ky_so__OUTGOING}>
                        <Button
                          className={'digital-signature'}
                          type="text"
                          onClick={() =>
                            message.info(
                              'Chỉ ký được file PDF, vui lòng chọn file khác!'
                            )
                          }>
                          Ký số
                        </Button>
                      </AccessControlAction>
                    ) : (
                      <AccessControlAction
                        aclActionType={ACL_ACTION_TYPE.ky_so__OUTGOING}>
                        <Popconfirm
                          placement="top"
                          title={'Hãy chọn loại ký'}
                          onConfirm={() => handleOpenPopupSign(file, index)}
                          okText="Ký tùy chọn"
                          cancelText="Ký mặc đinh"
                          onCancel={() => handleSignSavis(file, index)}>
                          <Button
                            className={'digital-signature'}
                            type="text"
                            onClick={() => handleBeforeSign(file, index)}>
                            Ký số
                          </Button>
                        </Popconfirm>
                      </AccessControlAction>
                    )} */}
                    {
                      <Button
                        className={'rename'}
                        type="text"
                        onClick={() => {
                          setIsRenameFileUpdate(false)
                          handleOpenPopupRenameFile(file, index)
                        }}>
                        Đổi tên
                      </Button>
                    }
                    <Tooltip title={'Xoá tập tin'}>
                      <DeleteOutlined
                        onClick={() =>
                          handleRemoveFileFromUploadList(file.uid, index)
                        }
                      />
                    </Tooltip>
                  </UploadFileListItem>
                ))}
                {renderListFileUpdate}
              </UploadFileListWrapper>
            }
            {/*  File đính kèm , file trình ký*/}
            {listFile?.map((file, index) => {
              return (
                <UploadFileListItem key={file.file_id}>
                  <div>
                    <PaperClipOutlined
                      style={{ color: 'blue', marginRight: 6 }}
                    />
                    <span
                      onClick={() =>
                        fileStore.handleDownloadFile(
                          file.file_id,
                          file.file_name
                        )
                      }>
                      {file.file_name}
                    </span>
                  </div>
                  <Tooltip title={'Xoá tập tin'}>
                    <DeleteOutlined
                      style={{ color: 'red' }}
                      onClick={() =>
                        handleRemoveListFileFromUploadList(file.file_id)
                      }
                    />
                  </Tooltip>
                </UploadFileListItem>
              )
            })}

            {showCompanyReceiver && (
              <Form.Item
                name={'organizations'}
                label={'Công ty nhận'}
                rules={[
                  { required: true, message: 'Vui lòng chọn công ty nhận!' },
                ]}>
                <DebounceSelect
                  mode="multiple"
                  placeholder={'-- Chọn công ty nhận văn bản --'}
                  fetchOptions={listOrgan}
                  style={{
                    width: '100%',
                  }}
                />
              </Form.Item>
            )}

            <FormActionFooter>
              <Button onClick={handleCancelCreate}>Huỷ bỏ</Button>
              <Button
                style={{ marginLeft: 10 }}
                type={'primary'}
                htmlType={'submit'}>
                {document ? 'Cập nhật' : 'Tạo mới'} văn bản
              </Button>
            </FormActionFooter>
          </Form>
        </Container>
      </ContentBlockWrapper>
      <PopupRenameFile
        isModalVisibleRenameFile={isModalVisibleRenameFile}
        handleCloseModalRenameFile={() => setIsModalVisibleRenameFile(false)}
        submitRenameFile={submitRenameFile}
        fieldsRenameFile={fieldsRenameFile}
        fileExt={fileExt}
      />
    </DashboardLayout>
  )
}

CateDocumentOutgoingDocUpdatePage.propTypes = {}

export default memo(
  inject(
    'commonStore',
    'cateDocumentStore',
    'fileStore',
    'authenticationStore',
    'loadingAnimationStore',
    'organizationStore',
    'cateStore',
    'signedDocumentStore',
    'electronicDocumentStore'
  )(observer(CateDocumentOutgoingDocUpdatePage))
)
